<div class="container page page-teacher-registration">

  <!-- not logged in -->
  <div class="" [ngClass]="{'d-none': isLoggedIn}">

    <div class="page-header">
      <h1 class="page-title">{{'Teacher registration' | translate}}</h1>
    </div>

    <div class="text-center">

      <p>{{'You are about to register as teacher.'}}</p>
      <p>1. {{'First you need to create an account, follow the button link below.'}}</p>
      <p>2. {{'After you created your account you will be redirected back to complete your registration.'}}</p>

      <button class="btn btn-primary" (click)="Login()">
        {{'Create account' | translate}}
      </button>

    </div>


  </div>

  <div [ngClass]="{'d-none': !isLoggedIn}">

    <div class="page-header">
      <h1 class="page-title">{{'Complete your teacher registration' | translate}}</h1>
    </div>

    <div class="row">

      <div class="col-12">

        <div class="form-group">
          <label>{{'First name' | translate}} *</label>
          <input type="text" class="form-control" name="given-name" autocomplete="given-name" [(ngModel)]="entity.firstName" />
          <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'firstName')">
            <p>{{'Please fill in your first name' | translate}}</p>
          </div>
        </div>

        <div class="form-group">
          <label>{{'Last name' | translate}} *</label>
          <input type="text" class="form-control" name="family-name" autocomplete="family-name" [(ngModel)]="entity.lastName" />
          <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'lastName')">
            <p>{{'Please fill in your last name' | translate}}</p>
          </div>
        </div>

        <div class="form-group">
          <label>{{'Phone number' | translate}}*</label>
          <input type="tel" class="form-control" name="tel" autocomplete="tel" [(ngModel)]="entity.phoneNumber" />
        </div>

        <h3>{{'Address' | translate}}</h3>

        <div class="row">

          <div class="col-sm-12">

            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'address', 'street')">
              <p>{{'Please fill in your street name' | translate}}</p>
            </div>

            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'address', 'number')">
              <p>{{'Please fill in your street number' | translate}}</p>
            </div>

            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'address', 'city')">
              <p>{{'Please fill in your city' | translate}}</p>
            </div>

            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'address', 'postalCode')">
              <p>{{'Please fill in your postal code' | translate}}</p>
            </div>

            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'address', 'country')">
              <p>{{'Please select your country' | translate}}</p>
            </div>

            <!-- address -->
            <div class="row">

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'Street' | translate}} *</label>
                  <input type="text" class="form-control" name="address-line1" autocomplete="address-line1" [(ngModel)]="entity.address.street" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'No.' | translate}} *</label>
                  <input type="text" class="form-control" name="address-line2" autocomplete="address-line2" [(ngModel)]="entity.address.number" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'Addition' | translate}}</label>
                  <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.address.numberSuffix" />
                </div>
              </div>

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'City' | translate}} *</label>
                  <input type="text" class="form-control" name="city" autocomplete="address-level2" [(ngModel)]="entity.address.city" />
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label>{{'Postal code' | translate}} *</label>
                  <input type="text" class="form-control" name="postal-code" autocomplete="postal-code" [(ngModel)]="entity.address.postalCode" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label>{{'Country' | translate}} *</label>
                  <select class="form-control" name="country" autocomplete="country" [(ngModel)]="entity.address.country">
                    <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
                  </select>
                </div>
              </div>

            </div>

            <h3>{{'School' | translate}}</h3>

            <div class="form-group">
              <label>{{'Select a school' | translate}}</label>
              <select class="form-control" [ngModel]="selectedSchoolId" (ngModelChange)="onSchoolChange($event)">
                <option value="">{{'Select a school' | translate}}</option>
                <option *ngFor="let school of schools" [value]="school.id">
                  {{school.name}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="schoolClasses.length > 0">
              <label>{{'Select classes' | translate}}</label>
              <div *ngFor="let cls of schoolClasses">
                <div class="custom-control custom-checkbox">
                  <input [id]="'class-' + cls.id" class="custom-control-input" type="checkbox"
                    [checked]="isClassSelected(cls.id!)" (change)="toggleClass(cls.id!)" />
                  <label [for]="'class-' + cls.id" class="custom-control-label">{{cls.name}}</label>
                </div>
              </div>
            </div>

            <div class="form-group mt-3">
              <div class="custom-control custom-checkbox">
                <input id="gdprPolicy" class="custom-control-input" type="checkbox" [(ngModel)]="hasAcceptedGdprPolicy" />
                <label for="gdprPolicy" class="custom-control-label">
                  {{'I accept the privacy policy' | translate}} *
                </label>
              </div>
            </div>

            <div class="btn-toolbar">
              <button class="btn btn-primary ml-auto" (click)="Register()" [disabled]="!hasAcceptedGdprPolicy">
                {{'Register' | translate}}
              </button>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>

</div>
